import { render, staticRenderFns } from "./DetailPage.vue?vue&type=template&id=05099b02&scoped=true&"
import script from "./DetailPage.vue?vue&type=script&lang=ts&"
export * from "./DetailPage.vue?vue&type=script&lang=ts&"
import style0 from "./DetailPage.vue?vue&type=style&index=0&id=05099b02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05099b02",
  null
  
)

export default component.exports